export default "__VITE_ASSET__DgPoOXSr__"